module.exports = {
    apiKey: "AIzaSyA_dfEO-Gh9IDVOlNg-JklvP6CqmSMZo-g",
    authDomain: "jour-econom-boundr-transform.firebaseapp.com",
    databaseURL: "https://jour-econom-boundr-transform.firebaseio.com",
    projectId: "jour-econom-boundr-transform",
    storageBucket: "jour-econom-boundr-transform.appspot.com",
    messagingSenderId: "1021482223658",
    appId: "1:1021482223658:web:5917697b15f482229adb53"
};